import { render, staticRenderFns } from "./ThreadActionsStandard.vue?vue&type=template&id=6f628078&scoped=true&"
import script from "./ThreadActionsStandard.vue?vue&type=script&lang=js&"
export * from "./ThreadActionsStandard.vue?vue&type=script&lang=js&"
import style0 from "./ThreadActionsStandard.vue?vue&type=style&index=0&id=6f628078&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f628078",
  null
  
)

export default component.exports